import {Balance, BalanceRestModel} from './balance.model';

/**
 * This object represents an User as it is received from the server
 * TODO : Maybe it could be good to rename this in UserHolder and create a new User object
 * @see Event and EventHolder
 */

export enum Setting {
  ENABLE_MONTHLY_TIMESHEET = 'ENABLE_MONTHLY_TIMESHEET',
  TIMESHEETS_APPROVED_BY = 'TIMESHEETS_APPROVED_BY',
}

export abstract class AbstractUser {
  id = 0;
  userProfile = '';
  userLogin = '';
  userPassword = '';
  userFirstName = '';
  userName = '';
  userMailAddress = '';
  userPhoneNumber = '';
  userSenorityDate: Date;
  userPasswordTmp = false;
  userSalt = '';
  avatar: string;
  userStatus: string;
  availability: string;
  settings: Record<string, string> = {};
  recordId: string;
  taxResidence: string = '';
  partTime = false;
  parentalLeave = false;
  mission: { code: string, label: string, client: string };
  /* Used for filtering */
  visible = true;

  constructor(userId = 0) {
    this.id = userId;
  }

  equals = (o: any): boolean => {
    return this.id === o.id;
  };
}

export class User extends AbstractUser {
  balances: Balance[];

  constructor(userId = 0) {
    super(userId);
  }

}

export class UserRestModel extends AbstractUser {
  balances: BalanceRestModel[];

  constructor(userId = 0) {
    super(userId);
  }

  toUserModel(): User {
    const res = new User();
    return {
      ...res,
      balances: this.balances.map(balance => {
          const result = Object.assign(new BalanceRestModel(), balance);
          return result.toBalanceModel();
        }
      )
    };
  }
}
